import moment from 'moment'
import _ from 'loadsh'
import _co from './const'
import common from './common'
import html2canvas from 'html2canvas'

const pptPeriodMap = {
    "day": "daily",
    "month": "monthly"
};

const companyHealthLabelMap = {
    "positive": "best",
    "alert": "good",
    "negative": "nomal"
};


export default {
    //获取报告pptCode
    getReportPptCode(entityType, entity, period) {
        if (!entityType || !period)
            return ""
        if (entityType == "industry") {
            return entity == "金融业" ? `xinhua_${pptPeriodMap[period]}_hy` : `xinhua_${pptPeriodMap[period]}_hy_nonsub`;
        }
        return `xinhua_${pptPeriodMap[period]}_qy`;

    },
    //获取对比pptCode
    getComparePptCode(entityType) {
        if (!entityType)
            return ""
        if (entityType == "industry")
            return `xinhua_compare_hy`;

        return `xinhua_compare_qy`;

    },
    htmlTocanvas(ref, option = {scale: 2}) {
        return html2canvas(ref, option).then((canvas) => {
            return canvas.toDataURL("image/jpeg");
        })
    },

    /*  报告   */
    healthTrendData_ppt(option) {//ppt - 舆情健康指数趋势
        let {
            id_name = "p1_1_qushi_line",
            title = "1·1 舆情健康指数趋势",
            type = "chart",
            text = "", labelData, target1, target2
        } = option;

        let data = [["日期", ...labelData]];
        _.forEach(target1, t => {
            let info = _.find(target2, {date: t.date})
            data.push([moment(t.date).format("MM/DD"), t.value, info && info.value || 0])
        })
        return {
            id_name, title, type, data, "text": common.delHtmlTag(text)
        };
    },
    subEntityHealth_ppt(option) {//ppt - 子行业舆情健康指数
        let {
            id_name = "p1_zihye_table",
            type = "table",
            title = "1·2 子行业舆情健康指数",
            heads = ["排名", "排名", "舆情健康指数（分）"],
            items,
            content: text
        } = option;

        let data = [heads];
        _.forEach(items, (item, index) => {
            data.push([index + 1, item.name, item.value])
        })
        return {id_name, title, type, data, text}
    },
    companyHealthLabel_ppt(list) {
        let arr = [];
        _.forEach(list, l => {
            arr.push(this.companyHealthItemLabel_ppt({
                id_name: `p1_zs_${companyHealthLabelMap[l.key]}_label`,
                data: l.title
            }))
            arr.push(this.companyHealthItemLabel_ppt({
                id_name: `p1_zs_${companyHealthLabelMap[l.key]}_label`,
                data: l.label
            }))
        })
        return arr;

    },
    companyHealthItemLabel_ppt(option) {
        let {id_name = "p1_zs_best_label", type = "text", data} = option;
        return {id_name, type, data: data};

    },
    companyHealthContent_ppt(option) {
        let {id_name = "p1_2_zhishufb_intro", type = "text", text} = option;

        return {id_name, type, data: common.delHtmlTag(text)};
    },
    companyHealthData_ppt(option) {
        let list = option?.list || []
        let companyHealths = _.map(["best", "good", "normal"], label => {
            let key = _co.companyHealthLabelPptMap[label];
            let info = _.find(list, {key});
            let items = info && info.companies && info.companies.slice(0, 5) || [];
            return {
                "id_name": `p1_2_zhishufb_${label}`,
                "type": "text",
                "data": `${items.join("\n")}`
            }
        })
        return companyHealths;
    },
    /**
     * 饼图
     当总数为0时， data数据返回:
     [[" ", "事件数"],["暂无数据", 0]]
     */
    pieData_ppt(option) {
        let {
            id_name = "p1_3_yxli_pie",
            title = "1·2 传播影响力分布",
            type = "chart",
            subtype = "pie",
            text,
            list,
            heads = [" ", "事件数"],
            unit ="篇"
        } = option;
        let data = [];

        if (!_.sumBy(list, "value")) {
            data = _.concat(data, [["暂无数据 ", 0], ["暂无数据", 0]])
        }else{
            _.forEach(list, l => {
                // data.push([l.name || l.label, l.value])
                data.push([`${l.name || l.label}\n${l.percent}% ${l.articleCount || l.count || 0}${unit}`, l.value])
            })
        }
        data = [heads].concat(data)
        return {id_name, title, type, subtype, data, text: common.delHtmlTag(text)};
    },
    /**
     * 注意：
     * TODO：table数据 和 bar数据顺序相反
     * TODO：因ppt有默认值， 需补全影响力
     */
    effectTendencyBar_ppt(option) {
        let {id_name = "p1_3_yxli_bar", type = "chart", list} = option;
        let data = [["", "敏感事件", "中性事件", "正面事件"]];

        _.forEach(_.orderBy(list, ["level"], ["desc"]), l => {
            data.push([l.name, l.negative, l.neutral, l.positive])
        })
        return {id_name, type, data}
    },

    effectTendencyTable_ppt(option) {
        let {id_name = "p1_3_yxli_table", type = "table", list} = option;
        let data = [["事件","全部报道"]];
        _.forEach(list, l => {
            data.push([l.value, l.articleCount])
        });
        return {id_name, type, data}
    },
    riskTable_ppt(option) { //处理银保风险或者内容风险
        let {
            id_name = "p2_1_fengx10_table",
            title = "2·1 监管关注的十类风险",
            type = "table",
            text,
            list,
            heads = [""]
        } = option;

        let data = [];
        _.forEach(list, l => {
            data.push([l.category, l.count])
        })

        data = [heads].concat(data)
        return {id_name, title, type, data, text: common.delHtmlTag(text)};
    },
    /**
     * 处理银保风险或内容风险
     * 银保风险和内容风险默认展示10个；
     */
    riskBar_ppt(option) {
        let {id_name = "p2_1_fengx10_bar", type = "chart", list, heads = []} = option;
        let data = [];
        _.forEach(_.reverse(list), l => {
            let per = parseInt(l.per)
            data.push([l.category, per, 100 - per])
        })
        // if (riskType == "contentRisk") {
        //     let diff = 5 - data.length;
        //     if (diff) {
        //         _.forEach(_.range(diff, 0), () => {
        //             data = [["", "", ""]].concat(data)
        //         })
        //     }
        // }
        data = [heads].concat(data);

        return {id_name, type, data};
    },

    tendenyBar_ppt(option) {
        let {id_name = "p3_1_qudao_bar", title = "3·1 渠道报道倾向", type = "chart", text, list, heads = [""]} = option;
        let data = [heads];
        _.forEach(_.orderBy(list, ["level"], ["desc"]), l => {
            data.push([l.name, l.negative, l.neutral, l.positive, l.total])
        })
        return {id_name, title, type, data, text: common.delHtmlTag(text)}
    },
    /**
     * 媒体报道倾向 Table：最多展示5个媒体
     * TODO 媒体不够，需补全数据，数组内容： [" ", " ", " "]
     */
    mediaTable_ppt(option) {
        let {
            id_name = "p3_2_media_table",
            title = "3·2 媒体报道倾向",
            type = "table",
            list,
            heads = ["排名", "媒体", "敏感报道量"]
        } = option;
        let data = [];
        _.forEach(list, (l, index) => {
            data.push([index + 1, l.name, l.count])
        })
        // let diff = 5 - data.length;
        // if (diff) {
        //     _.forEach(_.range(diff, 0), () => {
        //         data.push([" ", " ", " "])
        //     })
        // }
        data = [heads].concat(data)
        return {id_name, title, type, data}

    },

    /**
     * 媒体报道倾向 Bar：最多展示5个媒体
     * TODO 媒体不够，需补全数据，数组内容： ["1", 0, 0]
     */
    mediaBar_ppt(option) {
        let {id_name = "p3_2_media_bar", type = "chart", list, heads = ["媒体", "敏感", "敏感舆情总量"], total = 0} = option;
        let data = [];
        _.forEach(_.orderBy(list, ["count"], ["asc"]), l => {
            data.push([l.name, l.count, total])
        })
        let diff = 5 - data.length;
        if (diff) {
            _.forEach(_.range(diff, 0), (index) => {
                data = [[`"${index}"`, 0, 0]].concat(data)
            })
        }
        data = [heads].concat(data)
        return {id_name, type, data};
    },

    /**
     * 媒体报道倾向 Per：最多展示5个媒体
     * TODO 媒体不够，需补全数据，数组内容： [" "]
     */
    mediaPercent_ppt(option) {
        let {id_name = "p3_2_media_table_percent", type = "chart", list} = option;
        let data = [];

        _.forEach(_.orderBy(list, ["percent"], ["desc"]), l => {
            data.push([`${l.percent}%`])
        })

        // let diff = 5 - data.length;
        // if (diff) {
        //     _.forEach(_.range(diff, 0), () => {
        //         data.push([" "])
        //     })
        // }
        return {id_name, type, data};
    },
    canvaImage_ppt(option) {
        let {
            id_name = "p4_positive_picture",
            type = "text",
            subtype = "picture",
            title = "",
            data,
            text = " "
        } = option;
        return {id_name, type, subtype, data, title, text: common.delHtmlTag(text)}
    },
    companyHealthStr_ppt(option) {
        let {entity} = option;

        return {
            "id_name": "p1_2_zhishufb_title",
            "type": "text",
            "data": ~["金融", "金融业"].indexOf(entity) ? "1·3 企业舆情健康指数分布" :"1·2 企业舆情健康指数分布",
            "text": ""
        };
    },
    soundTrendChart_ppt(option) {
        let {
            id_name = "qym_p4_fwqs_line",
            type = "chart",
            title = "4·1 发文趋势",
            list,
            heads = ["日期", "报道量"],
            text = ""
        } = option;

        // let soundTrendArr = _.chain(list).map(item => {
        //     return {
        //         dateStr: item.date.split(" ")[0],
        //         count: item.value
        //     }
        // }).groupBy("dateStr").map((v, k) => {
        //     let count = _.sumBy(v, "count");
        //     return {
        //         dateStr: k,
        //         count
        //     }
        // }).value();

        let data = [heads];
        _.forEach(list, s => {
            data.push([moment(s.date).format("MM/DD HH:mm"), s.value])
        })
        return {id_name, title, type, data, text: common.delHtmlTag(text)}

    },

    /*  对比   */

    //舆情健康指数趋势
    lineHealth_ppt(option) {
        let {
            id_name = "p1_1_qushi_line",
            type = "chart",
            title = "1·1 舆情健康指数趋势",
            target1,
            target2,
            heads = [],
            text = ""
        } = option;

        let data = [heads];
        _.forEach(target1, (l, index) => {
            let target2Health = target2[index] && target2[index].value || 0;
            data.push([moment(l.date).format("MM/DD"), l.value, target2Health])
        })

        return {id_name, title, type, data, text}
    },
    //地域健康指数
    areaHealthBar_ppt(option) {
        let {
            id_name = "cmp_hy_diqzhis_1_bar",
            type = "chart",
            title = "1·2 地域健康指数",
            list,
            heads = ["", ""],
            text = ""
        } = option;

        let data = [heads];
        _.forEach(list, (l) => {
            data.push([l.province, l.health])
        })

        return {id_name, title, type, data, text}
    },
    //事件影响力分析

    affectBar_ppt(option) {
        let {
            id_name = "cmp_hy_yxli_bar",
            type = "chart",
            title = "1·3 事件影响力分析",
            heads,
            target1,
            target2,
            text = ""
        } = option;

        let data = [heads];
        _.forEach(target1, (l, index) => {
            let target2Total = target2[index] && target2[index].total || 0;
            data.push([l.name, l.total, target2Total])
        })

        return {id_name, title, type, data, text}
    },

    //风险统计分布
    riskStatsBar_ppt(option) {
        let {
            id_name = "cmp_hy_10fx_1_bar",
            type = "chart",
            title = "2·1 风险等级及等级分布",
            list,
            heads,
            text = ""
        } = option;

        let data = [heads];
        _.forEach(list.slice(0, 4), (l) => {
            data.push([l.category, l.count])
        })

        return {id_name, title, type, data, text}
    },

    //风险等级分布
    riskLevelBar_ppt(option) {
        let {
            id_name = "cmp_hy_fxdji_bar",
            type = "chart",
            target1,
            target2,
            heads,
        } = option;

        let data = [heads];
        _.forEach(target1, (l, index) => {
            let target2Count = target2[index] && target2[index].count || 0;
            data.push([l.label, l.count, target2Count])
        })

        return {id_name, type, data}
    },

    //风险企业
    //section1: 健康度小于75分的企业数；
    //section2：健康度大于等于75分的企业数；
    riskCompany_ppt(option) {
        let {
            title, name, section1, section2, total, text,
            pieIdName, titleIdName, infoIdName,
        } = option;
        let riskCompanyPie = this.riskCompanyPie_ppt({title, id_name: pieIdName, text, section1, section2});
        let riskCompanyTitle = this.moduleStr_ppt({
            id_name: titleIdName,
            data: name
        });
        let riskCompanyInfo = this.riskCompanyLabelInfo_ppt({id_name: infoIdName, count: section1, total});


        return [riskCompanyPie, riskCompanyTitle, riskCompanyInfo];
    },
    riskCompanyPie_ppt(option) {
        let {
            id_name = "cmp_hy_fxqiye_1_pie",
            type = "chart",
            subtype = "pie",
            title,
            heads = [" ", "数量"],
            section1,
            section2,
            text = ""
        } = option;

        let data = [heads,
            ["低于75分的风险企业", section1],
            ["高于75分的风险企业", section2]
        ];
        return {id_name, type, title, subtype, data, text}
    },

    riskCompanyLabelInfo_ppt(option) {
        let {
            id_name = "cmp_hy_fxqiye_1_label_infor",
            type = "text",
            count,
            total,

        } = option;
        return {id_name, type, data: `低于75分的风险企业${count}家 占比${common.formatPercent(count, total)}%`}
    },

    channelStats_ppt(option) {
        let {
            id_name = "cmp_hy_qudaos_bar",
            type = "chart",
            target1,
            target2,
            heads,
            text = ""
        } = option;

        target1 = _.orderBy(target1, ["level"], ["asc"]);
        target2 = _.orderBy(target2, ["level"], ["asc"]);
        let data = [heads];
        _.forEach(target1, (l, index) => {
            let target2total = target2[index] && target2[index].total || 0;
            data.push([l.name, l.total, target2total])
        })

        return {id_name, type, data, text}
    },


    comparePicture_ppt(option) {
        let {
            id_name = "p4_positive_picture",
            type = "text",
            subtype = "picture",
            data
        } = option;

        return {id_name, type, subtype, data}
    },

    compareMediaTable_ppt(option) {
        let {
            id_name = "p3_2_media_table",
            type = "table",
            data
        } = option;

        return {id_name, type, data}
    },
    compareMediaBar_ppt(option) {
        let {
            id_name = "p3_2_media_bar",
            type = "chart",
            heads = ["", "敏感占比", "其他占比"],
            list,
        } = option;
        let data = [heads];
        _.forEach(_.reverse(_.cloneDeep(list)), l => {
            data.push([l.item, l.percent, 100 - l.percent])
        })
        return {id_name, type, data}
    },
    compareMediaTablePercent_ppt(option) {
        let {
            id_name = "p3_2_media_table_percent",
            type = "table",
            list,
        } = option;
        let data = [];

        _.forEach(list, l => {
            data.push([`${l.percent}%`])
        })
        return {id_name, type, data}
    },

    moduleStr_ppt(option) {
        let {
            id_name,
            type = "text",
            data = ``
        } = option;

        return {id_name, type, data: common.delHtmlTag(data)}
    }

}